export * from "./omni-element.js";
export * from "./omni-stylesheets.js";
export * from "./omni-util.js";
export * from "./controllers/document-element-clip-controller.js";
export * from "./mixins/scroll-reset-mixin.js";
export * from "./mixins/document-element-clip-mixin.js";
export * from "./mixins/draggable-mixin.js";
export * from "./api/image-api.js";
export * from "./deprecated-export.js";
import { OmniStyle } from "./component/omni-style/omni-style.js";
import { OmniIcon } from "./component/omni-icon/omni-icon.js";
import { OmniCardGrid } from "./component/omni-card-grid/omni-card-grid.js";
import { OmniToolbar } from "./component/omni-toolbar/omni-toolbar.js";
export * from "./component/omni-context-provider/omni-context-provider.js";
import { OmniContextProvider } from "./component/omni-context-provider/omni-context-provider.js";
import { contextConsumerMixin } from "./context-consumer.js";
export * from "./component/omni-table/omni-table.js";
export * from "./component/omni-select.js";
export * from "./component/omni-optgroup.js";
export * from "./component/omni-option.js";
import { OmniImgUpload } from "./component/omni-img-upload/omni-img-upload.js";
import { OmniSearch } from "./component/omni-search/omni-search.js";
export * from "./lit-reexports.js";
import { default as default2 } from "./color.js";
import { OmniDropdown } from "./component/omni-dropdown/omni-dropdown.js";
export * from "./component/omni-dropdown/omni-dropdown.types.js";
import { OmniLoadingIndicator } from "./component/omni-loading-indicator/omni-loading-indicator.js";
import { OmniBadge } from "./component/omni-badge/omni-badge.js";
import { OmniDialog } from "./component/omni-dialog/omni-dialog.js";
import { OmniModalProgress } from "./component/omni-modal-progress/omni-modal-progress.js";
import { OmniSwitch } from "./component/omni-switch/omni-switch.js";
import { OmniTile } from "./component/omni-tile/omni-tile.js";
import { OmniAppLayout } from "./component/omni-app-layout/omni-app-layout.js";
import { OmniTheme } from "./component/omni-theme/omni-theme.js";
import { OmniCard } from "./component/omni-card/omni-card.js";
import { ClickOutsideController } from "./controllers/click-outside-controller.js";
import { OmniMediaEmbed } from "./component/omni-media-embed/omni-media-embed.js";
import { OmniCheckbox } from "./component/omni-checkbox/omni-checkbox.js";
import { OmniRadio } from "./component/omni-radio/omni-radio.js";
import { OmniRadioGroup } from "./component/omni-radio-group/omni-radio-group.js";
import { OmniRangeSlider } from "./component/omni-range-slider/omni-range-slider.js";
import { OmniImageInput } from "./component/omni-img-input/omni-img-input.js";
import { OmniTooltip } from "./component/omni-tooltip/omni-tooltip.js";
import { OmniChip } from "./component/omni-chip/omni-chip.js";
import { OmniOverlay } from "./component/omni-overlay/omni-overlay.js";
import { DragAndDropController, moveItemsInArray } from "./controllers/drag-and-drop-controller.js";
import { OmniIconActions } from "./component/omni-icon-action/omni-icon-action.js";
import { OmniTextarea } from "./component/omni-textarea/omni-textarea.js";
import { DraggableController } from "./controllers/draggable-controller.js";
import { OmniMarkdown } from "./component/omni-markdown/omni-markdown.js";
import { OmniProgressBar } from "./component/omni-progress-bar/omni-progress-bar.js";
import { OmniDotLoader } from "./component/omni-dot-loader/omni-dot-loader.js";
import { OmniPagination } from "./component/omni-pagination/omni-pagination.js";
let version = "7.28.3";
if (Number.isNaN(parseInt(version, 10))) {
  version = "next";
}
window.omniUIVersions = window.omniUIVersions || [];
window.omniUIVersions.push(version);
const breakingChangeWarning = (versions) => {
  return !versions.map((v) => v.slice(0, 1)).every((v, i, arr) => v === arr[0]);
};
if (window.omniUIVersions.length > 1 || window.litHtmlVersions.length > 1 || window.litElementVersions.length > 1) {
  console.warn(
    `Omni UI: found multiple versions of one of the following base libraries:

      omni-ui (${window.omniUIVersions.join(", ")})
      lit-element (${window.litElementVersions.join(", ")})
      lit-html (${window.litHtmlVersions.join(", ")})
    `
  );
  if (breakingChangeWarning(window.omniUIVersions))
    console.warn(`You have different major versions of Omni-UI loaded. This may cause unexpected behavior.`);
}
export {
  ClickOutsideController,
  default2 as Color,
  contextConsumerMixin as ContextConsumerMixin,
  DragAndDropController,
  DraggableController,
  OmniAppLayout,
  OmniBadge,
  OmniCard,
  OmniCardGrid,
  OmniCheckbox,
  OmniChip,
  OmniContextProvider,
  OmniDialog,
  OmniDotLoader,
  OmniDropdown,
  OmniIcon,
  OmniIconActions,
  OmniImageInput,
  OmniImgUpload,
  OmniLoadingIndicator,
  OmniMarkdown,
  OmniMediaEmbed,
  OmniModalProgress,
  OmniOverlay,
  OmniPagination,
  OmniProgressBar,
  OmniRadio,
  OmniRadioGroup,
  OmniRangeSlider,
  OmniSearch,
  OmniStyle,
  OmniSwitch,
  OmniTextarea,
  OmniTheme,
  OmniTile,
  OmniToolbar,
  OmniTooltip,
  moveItemsInArray
};
//# sourceMappingURL=index.js.map
